import React from 'react';
import type { Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
    marginTop: '128px',
    maxWidth: '625px',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  subtext: {
    marginTop: theme.spacing(2),
  },
}));

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const NotFound = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="h3">Sorry, page not found.</Typography>
        <Typography variant="body2" className={classes.subtext}>
          The page you're looking for has been removed, renamed, or unavailable.
        </Typography>
      </div>
    </div>
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default NotFound;
